import React, { useEffect, useState } from 'react';
import { Tooltip, Modal } from 'antd';
import { useRecoilState, useRecoilValue } from 'recoil';
import * as Yup from 'yup';
import { Button, Col, FormDatePicker, FormInput, FormSelect, FormSubmitButton, FormTextArea, MasterDetailForm, Row } from '@digital/ui';
import { ISasPropostaOrdemCompra, ISasPropostaOrdemCompraDocs, naoNegociarEnvioNegociacaoMinutaContratual, negociarEnvioNegociacaoMinutaContratual } from '@app/api/sas/sasProposta';
import { downloadArquivo } from '@app/api/sas/sasDocumentoOrdemCompra';
import { ModalInclusaoMultAnexo, Space, UploadFile, Visibility } from '@app/components';
import { editandoState, modalAcoesIdState, reloadVendorListState, vendorListDocsState } from '../atoms';
import { isObjNotEmpty, vtObjToFormData } from '@app/helpers/objHelper';
import { EStatusGenerico } from '@app/enums/EStatusGenerico';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';

interface IProps {
    sasProposta: ISasPropostaOrdemCompra;
}

export const BotoesEnvioNegociacaoMinutaContratual = ({ sasProposta }: IProps) => {

    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);

    const [exibirModal, setExibirModal] = useState(false);
    const [initialValues, setInitialValues] = useState<any>({} as any);
    const [editando, setEditando] = useRecoilState(editandoState);

    const vendorListDocs = useRecoilValue(vendorListDocsState);
    const [doc, setDoc] = useState<ISasPropostaOrdemCompraDocs>({} as ISasPropostaOrdemCompraDocs);

    useEffect(() => {
        setInitialValues({
            statusEnvioNegociacaoMinutaContratual: sasProposta.statusEnvioNegociacaoMinutaContratual,
            proponente: sasProposta.sasFornecedorOcNome,
            dataEnvioMinutaPreenchida: sasProposta.dataStatusEnvioNegociacaoMinutaContratual,
            dataPrazoDevolutiva: sasProposta.dataPrazoDevolutivaEnvioNegociacaoMinutaContratual,
            observacoes: sasProposta.observacoesEnvioNegociacaoMinutaContratual,
            justificativa: sasProposta.justificativaEnvioNegociacaoMinutaContratual,
        });

        var doc = vendorListDocs.find(f => f.id == sasProposta.id);
        if (isObjNotEmpty(doc)) {
            setDoc(doc || {} as ISasPropostaOrdemCompraDocs);
        }
    }, [exibirModal]);

    const handleCancel = () => {
        setExibirModal(false);
    };

    const handleSubmit = (values: any) => {
        const form = vtObjToFormData(values);
        form.append('sasPropostaId', sasProposta.id);


        if (editando.sasPropostaId == sasProposta.id) {
            Modal.confirm({
                title: <>{editando.justificativa}</>,
                content: <ModalConfirmContentJustificativa
                    texto='É necessário informar a justificativa para a alteração.'
                    setJustificativa={e => {
                        form.set('justificativaEdicao', e);
                    }} />,
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk: async (e) => {
                    form.append('editando', 'true');
                    return new Promise<void>((resolve, reject) => {
                        negociarEnvioNegociacaoMinutaContratual(sasProposta.id, form)
                            .then((data: any) => {
                                if (data && data.valid) {
                                    setReloadVendorList(!reloadVendorList);
                                    handleCancel();
                                    return resolve();
                                } else {
                                    if (data.notifications && data.notifications.length > 0) {
                                        const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                            return c.property == 'justificativaEdicao';
                                        });
                                        if (erroJustificativaEdicao >= 0) {
                                            return reject();
                                        }
                                    }
                                }
                            });
                    });
                },
                onCancel: () => { setModalAcoesId(''); }
            });
        } else {
            negociarEnvioNegociacaoMinutaContratual(sasProposta.id, form)
                .then((data: any) => {
                    if (data && data.valid) {
                        setReloadVendorList(!reloadVendorList);
                        handleCancel();
                    }
                });
        }
    };


    const naoNegociar = async (idRecord: string, values: any): Promise<boolean> => {

        const form = vtObjToFormData(values);
        form.append('sasPropostaId', sasProposta.id);

        if (editando.sasPropostaId == idRecord) {
            Modal.confirm({
                title: <>{editando.justificativa}</>,
                content: <ModalConfirmContentJustificativa
                    texto='É necessário informar a justificativa para a alteração.'
                    setJustificativa={e => {
                        form.set('justificativaEdicao', e);
                    }} />,
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk: async (e) => {
                    form.append('editando', 'true');
                    return new Promise<boolean>((resolve, reject) => {
                        naoNegociarEnvioNegociacaoMinutaContratual(idRecord, form)
                            .then((data: any) => {
                                if (data && data.valid) {
                                    setReloadVendorList(!reloadVendorList);
                                    return resolve(true);
                                } else {
                                    if (data.notifications && data.notifications.length > 0) {
                                        const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                            return c.property == 'justificativaEdicao';
                                        });
                                        if (erroJustificativaEdicao >= 0) {
                                            return reject(false);
                                        }
                                    }
                                }
                            });
                    });
                },
                onCancel: () => { setModalAcoesId(''); }
            });
        } else {
            await naoNegociarEnvioNegociacaoMinutaContratual(idRecord, form)
                .then((data: any) => {
                    if (data && data.valid) {
                        setReloadVendorList(!reloadVendorList);
                        return true;
                    }
                    return false;
                });
        }

        return true;
    };

    return (
        <Visibility visible={true}>
            <Row align='middle' justify='center' style={{ display: 'flex' }}>

                <Visibility visible={sasProposta.statusEnvioNegociacaoMinutaContratual !== EStatusGenerico.NAO_NEGOCIAR ||
                    editando.sasPropostaId === sasProposta.id}>
                    <Tooltip title="Enviar">
                        <Button icon='commons-ok' onClick={() => { setExibirModal(true); }} />
                    </Tooltip>
                </Visibility>

                <Visibility visible={sasProposta.statusEnvioNegociacaoMinutaContratual !== EStatusGenerico.MINUTA_VALIDADA ||
                    editando.sasPropostaId === sasProposta.id}>
                    <Space ml={4} />
                    <ModalInclusaoMultAnexo
                        buttonIcon="commons-cancel"
                        buttonTooltip='Não Enviar'
                        onSubmit={async (values) => {
                            const data = await naoNegociar(sasProposta.id, values);
                            setModalAcoesId('');
                            return data;
                        }}
                        showUploadArquivos={false}
                        showJustificativa={true}
                        textButtonSave="Salvar"
                        initialValues={initialValues}
                        disabledFields={editando.sasPropostaId !== sasProposta.id &&
                            sasProposta.statusEnvioNegociacaoMinutaContratual === EStatusGenerico.NAO_NEGOCIAR} />
                </Visibility>

            </Row>

            <Visibility visible={exibirModal}>

                <Modal
                    title="Negociar Minuta"
                    width="980px"
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <MasterDetailForm
                        key={`form_BotoesEnvioNegociacaoMinutaContratual_${sasProposta.id}`}
                        initialValues={initialValues}
                        actions={[
                            <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                            <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                        ]}
                        validationSchema={Yup.object().shape({
                            arquivo: isObjNotEmpty(doc) && doc.anexoEnvioNegociacaoMinutaContratual ? Yup.mixed().notRequired() : Yup.mixed().required('É necessário anexar um arquivo.'),
                            dataEnvioMinutaPreenchida: Yup.string().required('O campo é obrigatório.'),
                            dataPrazoDevolutiva: Yup.string().required('O campo é obrigatório.'),
                        })}
                    >
                        <Row>
                            <FormSelect
                                label='Status'
                                name='statusEnvioNegociacaoMinutaContratual'
                                value={sasProposta.statusEnvioNegociacaoMinutaContratual
                                    ? sasProposta.statusEnvioNegociacaoMinutaContratual
                                    : EStatusGenerico.PENDENTE}
                                options={[
                                    { text: EStatusGenerico.PENDENTE, value: EStatusGenerico.PENDENTE },
                                    { text: EStatusGenerico.EM_NEGOCIACAO, value: EStatusGenerico.EM_NEGOCIACAO },
                                    { text: EStatusGenerico.MINUTA_VALIDADA, value: EStatusGenerico.MINUTA_VALIDADA },
                                ]}
                                span={6}
                                disabled />

                            <FormInput
                                name="proponente"
                                label='Proponente'
                                value={sasProposta.sasFornecedorOcNome}
                                disabled
                                span={6} />

                            <FormDatePicker
                                label='Data do envio da Minuta preenchida'
                                name='dataEnvioMinutaPreenchida'
                                format='DD/MM/YYYY'
                                span={6} />

                            <FormDatePicker
                                label='Prazo para a Devolutiva'
                                name='dataPrazoDevolutiva'
                                format='DD/MM/YYYY'
                                span={6} />

                            <FormTextArea
                                label='Observações'
                                name='observacoes'
                                span={12} />

                            <FormTextArea
                                label='Justificativa'
                                name='justificativa'
                                span={12} />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <br></br>
                                <UploadFile
                                    idDoComponente='arquivo-BotoesEnvioNegociacaoMinutaContratual'
                                    type='primary'
                                    hasFile={false}
                                    hasLabel={true}
                                    icon='ui-upload'
                                    span={6} />
                                {isObjNotEmpty(doc) && doc.anexoEnvioNegociacaoMinutaContratual && (
                                    <Button
                                        icon='ui-download'
                                        type='primary'
                                        onClick={() => downloadArquivo(doc.anexoEnvioNegociacaoMinutaContratual.id, doc.anexoEnvioNegociacaoMinutaContratual.nome)} />
                                )}
                            </Col>
                        </Row>
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </Visibility>
    );
};
